import React from 'react'
import PropTypes from 'prop-types'
import AccordionElement from './AccordionElement'
import { withAccordion } from './withAccordion'

const Accordion = withAccordion(AccordionElement)(
  ({ renderAccordion, children, accordionProps }) => {
    return (
      <div>
        {renderAccordion(children, accordionProps)}
      </div>
    );
  }
)

Accordion.propTypes = {
  accordionProps: PropTypes.object,
}
Accordion.defaultProps = {
  accordionProps: {}
}
Accordion.Pane = ({ className, style, children }) => (
  <div className={className} style={style}>{children}</div>
)

export default Accordion



// WEBPACK FOOTER //
// ./src/components/accordions/Accordion.js